angular.module("ainapp")
    .controller("counterSalesReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Counter Sales Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                $scope.Branches = response.data;

            })


            $scope.Init = function () {

                $scope.filter = {
                    DateFrom: new Date(),
                    DateTo: new Date(),
                    BranchId: "",
                }
            }
            $scope.Init();






            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.DateFrom = $scope.filter.DateFrom;
                        o.data.DateTo = $scope.filter.DateTo;
                        o.data.BranchId = $scope.filter.BranchId;

                        o.data.FromMonth = $scope.filter.DateFrom.getMonth() + 1;
                        o.data.FromDay = $scope.filter.DateFrom.getDate();
                        o.data.FromYear = $scope.filter.DateFrom.getFullYear();

                        o.data.ToMonth = $scope.filter.DateTo.getMonth() + 1;
                        o.data.ToDay = $scope.filter.DateTo.getDate();
                        o.data.ToYear = $scope.filter.DateTo.getFullYear();

                        MainService.CounterSalesInReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },

                            BillNo: {
                                type: "string",
                            },

                            PayType: {
                                type: "string",
                            },

                            "AccountMaster.Name": {
                                type: "string",
                            },
                            "User.UserName": {
                                type: "string",
                            },

                            SubTotal: {
                                type: "number",
                            },
                            Taxable: {
                                type: "number",
                            },
                            TotalQuantity: {
                                type: "number",
                            },
                            TotalDiscount: {
                                type: "number",
                            },
                            TotalVAT: {
                                type: "number",
                            },
                            GrandTotal: {
                                type: "number",
                            },
                            IsPaymentDone: {
                                type: "boolean",
                            },
                            "Branch.Name": {
                                type: "string",
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                //                editable: false,
                //                pageable: true,
                //                toolbar: ["excel"],
                //                height: 600,
                //                resizable: true,
                //                dataSource: $scope.KendoSource,
                //                pageSize: 20,
                //                pageable: {
                //                    input: false,
                //                    refresh: true,
                //                    pageSizes: true,
                //                    info: true,
                //                },
                //                sortable: true,
                //                scrollable: true,
                //                filterable: true,
                //                groupable: false,


                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },









                columns: [
                    {
                        field: "BillNo",
                        title: "#",
                                            },
                    {
                        field: "AccountMaster.Name",
                        title: "Customer",
                                            },
                    {
                        field: "Branch.Name",
                        title: "Branch",
                                            },
                    {
                        field: "User.UserName",
                        title: "Created By",
                                            },
                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                                            },
                    {
                        field: "PayType",
                        title: "Pay Type",
                                            },
                    {
                        field: "SubTotal",
                        title: "Sub Total",
                        template: "<div style='text-align: right'>#=kendo.toString(SubTotal, 'n')#</div>",

                                            },
                    {
                        field: "TotalDiscount",
                        title: "Total Discount",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalDiscount, 'n')#</div>",

                                            },
                    {
                        field: "Taxable",
                        title: "Taxable",
                        template: "<div style='text-align: right'>#=kendo.toString(Taxable, 'n')#</div>",

                                            },
                    {
                        field: "TotalVAT",
                        title: "Total VAT",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalVAT, 'n')#</div>",

                                            },
                    {
                        field: "GrandTotal",
                        title: "Grand Total",
                        template: "<div style='text-align: right'>#=kendo.toString(GrandTotal, 'n')#</div>",

                                            },
                    {
                        field: "TotalQuantity",
                        title: "Total Qty",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalQuantity, 'n')#</div>",

                                            },
                    {
                        field: "IsPaymentDone",
                        title: "Payment Done?",
                        template: "<p ng-if='dataItem.IsPaymentDone'>Yes</p> <p ng-if='!dataItem.IsPaymentDone'>No</p>"
                                            },

                    ],
            };

            $scope.filterData = function () {
                console.log($scope.filter)
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refreshData = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }



        }])
